export default "__VITE_ASSET__86c3df61__"